var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('TopIndicators',{attrs:{"url":'/pan/xdr/indicators/info/top?limit=999'}})],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }